import { AnyAction } from 'redux';
import { RESET_STATE, PROFILE_LOADING, GET_MY_PROFILE, GET_MY_PROFILE_GRANTS } from '@app/store/constants';
import { IMyProfileGrants, IMyProfile } from '@app/models';

interface InitialUserState {
    myProfile: IMyProfile | undefined,
    myProfileGrants: Partial<IMyProfileGrants>,
    profileLoading: boolean
}

const initialState = {
    myProfile: undefined,
    myProfileGrants: {},
    profileLoading: false
};

export function myProfile(state: InitialUserState = initialState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case RESET_STATE:
            return initialState;
        case GET_MY_PROFILE:
            return {
                ...state,
                myProfile: payload
            };
        case GET_MY_PROFILE_GRANTS:
            return {
                ...state,
                myProfileGrants: payload
            };
        case PROFILE_LOADING:
            return {
                ...state,
                profileLoading: payload
            };
        default:
            return state;
    }
}